import { WeekMenu } from './lunchData';
import { getCurrentWeekInfo } from './dateUtils';
import { auth } from './firebase';

const GET_MENUS_API = 'https://europe-west1-dagens-l-tt.cloudfunctions.net/getMenus';
const UPDATE_MENU_API = 'https://europe-west1-dagens-l-tt.cloudfunctions.net/updateMenu';

/**
 * Fetch all weekly menus from Firestore via API
 */
export const fetchMenus = async (): Promise<WeekMenu[]> => {
  try {
    const response = await fetch(GET_MENUS_API, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    const allMenus: WeekMenu[] = data.menus || [];

    // Hämta nuvarande vecka och räkna ut nästa vecka
    const currentInfo = getCurrentWeekInfo();
    const nextWeek = ((currentInfo.week) % 52) + 1;
    const nextYear = currentInfo.week === 52 ? currentInfo.year + 1 : currentInfo.year;

    // Filtrera så att vi enbart returnerar denna och nästa vecka
    return allMenus.filter(m => 
      (m.week === currentInfo.week && m.year === currentInfo.year) ||
      (m.week === nextWeek && m.year === nextYear)
    );
  } catch (error) {
    console.error('Failed to fetch lunch menus:', error);
    return [];
  }
};

/**
 * Save or update a weekly menu to Firestore via API
 */
export const saveMenu = async (menu: WeekMenu): Promise<boolean> => {
  try {
    const user = auth.currentUser;
    const token = user ? await user.getIdToken() : '';
    
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(UPDATE_MENU_API, {
      method: 'POST',
      headers,
      body: JSON.stringify(menu),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return !!data.success;
  } catch (error) {
    console.error('Failed to save lunch menu:', error);
    return false;
  }
};
